import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Navigator } from 'src/app/components/menu/navigator';

@Component({
  selector: 'app-boyd-rewards-launch',
  templateUrl: './boyd-rewards-launch.component.html',
  styleUrls: ['./boyd-rewards-launch.component.scss'],
})
export class BoydRewardsLaunchComponent implements OnInit {

    public backgroundClass = "blue-background";
    public addStars:boolean = true;
    public boydLoginURL;

    constructor(
        protected platform: Platform,
        private appLinks: AppLinksService,
        private navigator: Navigator,
        private configService: ConfigService
    ) {
    
    }

    ngOnInit(){
        this.boydLoginURL = this.configService.getConfig().FEATURE_BOYD_LOGIN_URL ? this.configService.getConfig().FEATURE_BOYD_LOGIN_URL : 'https://rewards.boydgaming.com/' 
    }

    ionViewDidLoad() {
        
    }

    ionViewWillLeave() {
        
    }

    cancel(){
      this.navigator.dismissAll();
    }

    launchBoydApp(){
      if(this.platform.is('capacitor')){
        this.appLinks.openExternalPage(this.boydLoginURL);
        this.navigator.dismissAll();
      } else {
        this.appLinks.openExternalPage(this.boydLoginURL);
        this.navigator.dismissAll();
      }
        
    }

}
